import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useTranslation } from "../../../hooks/useTranslation";
import { ManualRegionPicker } from "../ManualRegionPicker";

interface IProps {
  open: boolean;
  onClose: () => void;
}

/**
 * Popup for setting the workspace's default region for manual addresses, opened
 * from the "Configure now" prompt in ManualAddressSection when no region is set
 * yet. The picker saves immediately on selection (dispatch to Redux), so simply
 * closing the dialog is enough — the host re-derives the region from the updated
 * workspace and reveals the coordinate fields.
 */
export const ManualRegionDialog: React.FC<IProps> = ({ open, onClose }) => {
  const { p } = useTranslation("contact_info");

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" sx={{ zIndex: 10002 }}>
      <DialogTitle>{p("manual_region_dialog_title")}</DialogTitle>
      <DialogContent sx={{ pt: "8px !important", overflow: "visible" }}>
        <ManualRegionPicker showLabel={false} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          {p("done")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
